import "zone.js";  // Included with Angular CLI.
import "froala-editor/js/plugins/code_view.min.js";
import "froala-editor/js/plugins/code_beautifier.min.js";
import { enableProdMode, provideZoneChangeDetection } from "@angular/core";
import { platformBrowser } from "@angular/platform-browser";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { LicenseManager } from "ag-grid-enterprise";
import {
    ModuleRegistry,
    ClientSideRowModelModule,
    ColumnAutoSizeModule,
    ColumnHoverModule,
    PinnedRowModule,
    RowAutoHeightModule,
    RowStyleModule,
    PaginationModule,
    CellSpanModule,
    CellStyleModule,
    HighlightChangesModule,
    TooltipModule,
    TextFilterModule,
    NumberFilterModule,
    DateFilterModule,
    CustomFilterModule,
    ExternalFilterModule,
    TextEditorModule,
    LargeTextEditorModule,
    SelectEditorModule,
    NumberEditorModule,
    DateEditorModule,
    CheckboxEditorModule,
    CsvExportModule,
    GridStateModule,
    ColumnApiModule,
    RowApiModule,
    ScrollApiModule,
    EventApiModule,
    ValidationModule,
    provideGlobalGridOptions
} from 'ag-grid-community';
import {
    FindModule,
    SetFilterModule,
    AdvancedFilterModule,
    CellSelectionModule,
    RichSelectModule,
    RowGroupingPanelModule,
    GroupFilterModule,
    ColumnsToolPanelModule,
    FiltersToolPanelModule,
    ColumnMenuModule,
    ContextMenuModule,
    ClipboardModule,
    StatusBarModule,
    ExcelExportModule,
    ServerSideRowModelModule,
    ServerSideRowModelApiModule,
    RowSelectionModule,
    themeBalham
} from 'ag-grid-enterprise';

import { setDefaultOptions } from "esri-loader";

// LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-119944}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Johnson,_Mirmiran_&_Thompson,_Inc.}_is_granted_a_{Multiple_Applications}_Developer_License_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{12}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{5_March_2027}____[v3]_[01]_MTgwNDIwNDgwMDAwMA==6c1330a8ee065d68e6798c34761fd0f2");
LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-119944}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Johnson,_Mirmiran_&_Thompson,_Inc.}_is_granted_a_{Multiple_Applications}_Developer_License_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{12}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{5_March_2027}____[v3]_[01]_MTgwNDIwNDgwMDAwMA==6c1330a8ee065d68e6798c34761fd0f2");


ModuleRegistry.registerModules([
    ClientSideRowModelModule,
    ColumnAutoSizeModule,
    ColumnHoverModule,
    PinnedRowModule,
    RowAutoHeightModule,
    RowStyleModule,
    PaginationModule,
    CellSpanModule,
    CellStyleModule,
    HighlightChangesModule,
    TooltipModule,
    TextFilterModule,
    NumberFilterModule,
    DateFilterModule,
    CustomFilterModule,
    ExternalFilterModule,
    TextEditorModule,
    LargeTextEditorModule,
    SelectEditorModule,
    NumberEditorModule,
    DateEditorModule,
    CheckboxEditorModule,
    CsvExportModule,
    GridStateModule,
    ColumnApiModule,
    RowApiModule,
    ScrollApiModule,
    EventApiModule,
    ValidationModule,
    FindModule,
    SetFilterModule,
    AdvancedFilterModule,
    CellSelectionModule,
    RichSelectModule,
    RowGroupingPanelModule,
    GroupFilterModule,
    ColumnsToolPanelModule,
    FiltersToolPanelModule,
    ColumnMenuModule,
    ContextMenuModule,
    ClipboardModule,
    StatusBarModule,
    ExcelExportModule,
    ServerSideRowModelModule,
    ServerSideRowModelApiModule,
    RowSelectionModule,
]);

if (environment.production) {
    enableProdMode();
}

const customTheme = themeBalham.withParams({
    backgroundColor: 'white',
    fontSize: 12,
    headerBackgroundColor: '#0d4458',
    headerTextColor: 'white',
    headerColumnResizeHandleColor: 'rgba(255,255,255,0.5)',
    rowBorder: '1px solid #d9dcde',
    rowHoverColor: '#ebebeb',
    oddRowBackgroundColor: '#f4f4f4',
    cellHorizontalPadding: 11,
});

provideGlobalGridOptions({
    theme: customTheme,
    suppressCutToClipboard: true,
    ensureDomOrder: true,
    suppressRowVirtualisation: true,
    suppressColumnVirtualisation: true,
    paginationPanels: ['pageSize', 'rowSummary', { type: 'pageSummary', suppressPageInput: true }],
});

platformBrowser().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.log(err));


setDefaultOptions({ version: '4.23' });
